import { CountryId, EmployeeRoleId, LanguageId } from '@previo/codebooks'
import type { SalesmanId } from '@previo/codebooks'
import { CrmModule } from '~/composables/usePermissionChecker'

enum UserTypeId {
  ROOT = 1,
  CUSTOMER = 2,
  PARTNER = 3,
  SALESMAN = 4,
  CONNECTOR = 5,
  GUEST = 6,
}

type Salesman = {
  id: number
  name: string
  isCountryDirector: boolean
  allCountries: boolean
  accessibleCountries: CountryId[]
  empoweringSalesmanIds: SalesmanId[]
}

type EmployeeInfo = {
  id: number
  name: string
  allCountries: boolean
  countryId: CountryId
  roleIds: EmployeeRoleId[]
  modules: CrmModule[]
  readOnlyModules: CrmModule[]
  countryIds: CountryId[]
}

type User = {
  id: number | null
  userTypeId: UserTypeId | null
  userName: string
  email: string
  languageId: LanguageId | null
  salesman: Salesman | null
  employee: EmployeeInfo | null
}

export { UserTypeId }
export type { User, Salesman, EmployeeInfo }
